import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue, isVariable } from '../../../../Fct/generics';
import { FaHandHoldingUsd } from 'react-icons/fa';
import { getAaveTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { A_TOKENS, LENDING_POOL_ADDRESSES } from '../constants';
export var Repay = createPlugin({
    protocol: 'AAVE',
    type: 'ACTION',
    method: 'repay',
    supportedContracts: LENDING_POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_lending_pool_v2' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getAaveTokens({ chainId: chainId }), isPreview: true, icon: FaHandHoldingUsd }),
                    amount: new FctValue({ destination: 'wei_amount', isPreview: true }),
                    rateMode: new FctValue({ options: [{ value: '1', name: 'stable' }, { value: '2', name: 'variable' }], isPreview: true }),
                    onBehalfOf: new FctAddress({}),
                },
            },
            output: {
                value: new FctValue({ innerIndex: 0 }),
            },
        });
    },
    requiredApprovals: function (params, _chainId, _walletAddress, _vaultAddress, _provider, _method, isEstimation) {
        var _a = params.methodParams, asset = _a.asset, amount = _a.amount, onBehalfOf = _a.onBehalfOf;
        var getValue = function () {
            if (isEstimation && isVariable(amount.value)) {
                return amount.estimatedValue;
            }
            return amount.value;
        };
        var value = getValue();
        if (!value)
            return [];
        return [
            {
                to: asset.value,
                from: onBehalfOf.value,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var to = params.to, _a = params.methodParams, amount = _a.amount, asset = _a.asset, onBehalfOf = _a.onBehalfOf, rateMode = _a.rateMode;
        if (!asset.value || !to.value || !amount.value || !onBehalfOf.value || !rateMode.value || !vaultAddress)
            return [];
        if (typeof amount.value !== 'string' ||
            typeof asset.value !== 'string' ||
            typeof rateMode.value !== 'string' ||
            typeof to.value !== 'string')
            return [];
        var assetData = A_TOKENS[chainId].find(function (token) { return token.underlyingAssetAddress.toLowerCase() === asset.value.toLowerCase(); });
        if (!assetData)
            return [];
        var debtToken = rateMode.value === '1' ? assetData.stableDebtTokenAddress : assetData.variableDebtTokenAddress;
        return [
            {
                address: vaultAddress,
                toSpend: [
                    {
                        token: asset.value,
                        amount: amount.value,
                    },
                    {
                        token: debtToken,
                        amount: amount.value,
                    },
                ],
                toReceive: [],
            },
        ];
    },
});
